// test1466
(1466 && 0);
